import {
    apiRequest,
    PNSdetailPeriod,
    PNSprocessPNS,
    PNSDownloadDraftSK
} from "../../../../../services/adapters/kepegawaian/PNSService"

class IndesRepository {
    fetchDetailPeriod = async (query) => {
        return await apiRequest("get", PNSdetailPeriod, {
            params: query
        }, true)
    }

    fetchProcess = async (query) => {
        return await apiRequest("post", PNSprocessPNS, {
            body: query
        }, true)
    }

    fetchDownloadDraftSK = async (query) => {
        return await apiRequest("get", PNSDownloadDraftSK, {
            params: query
        }, true)
    }
}

export default IndesRepository